import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import classnames from 'classnames';
import { isEmpty, isArray, uniqueId } from 'lodash';

import ButtonWithIcon from 'core.ui/ButtonWithIcon';
import Select from 'core.ui/Select';
import { orderStatus } from '../../core.utils/parser/orderStatus';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import { useDispatch } from 'react-redux';
export const useStyles = makeStyles({
	mainContainer: {
		margin: '16px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	pageButtons: {
		margin: 20
	},
	listMainContainer: { width: '1200px' },
	listTable: {},
	listTableHeader: {},
	listTableColumnsHeaders: {
		textAlign: 'center'
	},
	listTableActionColumnHeader: {
		width: '50px'
	},
	listTableBody: {},
	listEmptyListMessage: {
		padding: '10px',
		textAlign: 'center'
	},
	listTableRow: {},
	listTableCell: {
		textAlign: 'center'
	},
	listInCell: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center'
	},
	actionButton: {
		margin: '0 3px'
	}
});
const getItemStyle = (isDragging, draggableStyle) => ({
	...draggableStyle,

	...(isDragging && {
		background: "rgb(235,235,235)"
	})
})
function List({
	listMainContainerProp,
	className,
	list = [],
	columns = [],
	ids = [],
	emptyMessage,
	actions,
	customPage,
	numberPerPage = 10,
	filters = {},
	onPageChange,
	headers,
	productList,
	withPagination = true,
	onDragEnd
}) {
	const dispatch = useDispatch();
	const [ page, setPage ] = useState(1);
	const [ draggable, SetDraggable ] = useState(productList)
	const classes = useStyles();
	const handleDragEnd = (result)=> {
		if(!result.destination) return;
		const productsByHeaders = Array.from(productList.filter(product => !product.isArchived && product.header == headers));
		const auxProduct = productsByHeaders[result.destination.index]
		productsByHeaders[result.destination.index] = productsByHeaders[result.source.index]
		productsByHeaders[result.source.index] = auxProduct
		dispatch(onDragEnd(productsByHeaders))
    }
	const columnsHeaders = columns.map((c, i) => (
		<TableCell
			key={i}
			component="th"
			className={classnames('list-table-columns-headers', classes.listTableColumnsHeaders)}
		>
			{c}
		</TableCell>
	));
	const columnToFilter = Object.keys(filters)[0];
	const rowsWithId = list.map((data, index) => ({ id: ids[index], data }));
	const filteredRows =
		!isEmpty(filters) && !isEmpty(filters[columnToFilter])
			? rowsWithId.filter((el) => {
					if (isArray(filters[columnToFilter])) {
						return filters[columnToFilter].reduce((acc, f) => {
							if (el.data[columnToFilter].type === Select) {
								return acc || el.data[columnToFilter].props.value === f;
							} else {
								return acc || el.data[columnToFilter] === f;
							}
						}, false);
					} else {
						if (el.data[columnToFilter].type === Select) {
							return el.data[columnToFilter].props.value === filters[columnToFilter];
						} else {
							return el.data[columnToFilter] === filters[columnToFilter];
						}
					}
				})
			: rowsWithId;
	const currentPageRow =
		!onPageChange && numberPerPage > 0
			? filteredRows
					.slice((page - 1) * numberPerPage, page * numberPerPage)
					.map((row, rowIndex) => makeRow(row.data, rowIndex, classes, actions, row.id))
			: filteredRows.map((row, rowIndex) => makeRow(row.data, rowIndex, classes, actions, row.id));
	const handleLeftArrowClick = () => {
		if ((customPage || page) === 1) {
			return;
		}
		const newPage = (customPage || page) - 1;
		if (onPageChange) {
			onPageChange(newPage, numberPerPage);
		}
		setPage(newPage);
	};
	

	const handleRightArrowClick = () => {
		const newPage = (customPage || page) + 1;
		if (onPageChange) {
			onPageChange(newPage, numberPerPage);
		}
		setPage(newPage);
	};
	return (
		<div className={classes.mainContainer}>
			{withPagination && (
				<div className={classes.pageButtons}>
					<ButtonWithIcon
						className="list-left-arrow"
						onClick={handleLeftArrowClick}
						featherIcon="ArrowLeft"
					/>
					Page : {customPage || page}
					<ButtonWithIcon
						className="list-right-arrow"
						onClick={handleRightArrowClick}
						featherIcon="ArrowRight"
					/>
				</div>
			)}
			<TableContainer
				className={classnames('list-main-container', classes.listMainContainer, className)}
				style={!listMainContainerProp ? {} : listMainContainerProp}
			>
				<Table className={classnames('list-table', classes.listTable)}>
					<TableHead className={classnames('list-table-header', classes.listTableHeader)}>
						<TableRow>
							{columnsHeaders}
							{actions && (
								<TableCell
									component="th"
									className={classnames(
										'list-table-columns-headers',
										classes.listTableColumnsHeaders,
										classes.listTableActionColumnHeader
									)}
								/>
							)}
						</TableRow>
					</TableHead>
					{list.length > 0 && (
					<DragDropContext onDragEnd={handleDragEnd}>
					 <Droppable droppableId="list-table-body">
					  {	provided =>
						<TableBody className={classnames('rows', classes.listTableBody)} {...provided.droppableProps} ref={provided.innerRef}>
							{currentPageRow}
							{provided.placeholder}	
						</TableBody>
					   }
					 </Droppable>
					</DragDropContext>
					)}
					
				</Table>
				{list.length === 0 && (
					<div className={classnames('list-empty-list-message', classes.listEmptyListMessage)}>
						{emptyMessage}
					</div>
				)}
			</TableContainer>
			{withPagination && (
				<div className={classes.pageButtons}>
					<ButtonWithIcon
						className="list-left-arrow"
						onClick={handleLeftArrowClick}
						featherIcon="ArrowLeft"
					/>
					Page : {customPage || page}
					<ButtonWithIcon
						className="list-right-arrow"
						onClick={handleRightArrowClick}
						featherIcon="ArrowRight"
					/>
				</div>
			)}
		</div>
	);
}

export function makeRow(row, rowIndex, classes, actions, id) {
	const cells = row.map((cellInput, i) => makeCell(cellInput, i, classes));

	return (
			<Draggable key={id} draggableId={id} index={rowIndex}  >
				{(provided, snapshot) => (
					<TableRow key={rowIndex} 
					className={classnames('list-table-row', classes.listTableRow)} 
					{...provided.draggableProps} 
					{...provided.dragHandleProps} 
					ref={provided.innerRef}
					style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
					>
						{cells}
						{actions && makeActionsCell(id, actions, classes)}
					</TableRow>
				)}
			</Draggable>
	);
}

export function makeCell(input, inputKey, classes = {}) {
	if (Array.isArray(input)) {
		return (
			<TableCell key={inputKey}>
				<div className={classes.listInCell}>
					<ul>{input.map((el, i) => <li key={i}>{el}</li>)}</ul>
				</div>
			</TableCell>
		);
	}
	return (
		<TableCell className={classes.listTableCell} key={inputKey}>
			{input}
		</TableCell>
	);
}

export function makeActionsCell(id, actions, classes = {}) {
	const { handleEdit, handleDelete, handleDuplicate, showLogs } = actions;
	return (
		<TableCell>
			<div className={classes.listInCell}>
				{handleEdit && (
					<ButtonWithIcon
						className={classes.actionButton}
						onClick={() => handleEdit(id)}
						featherIcon="Edit"
					/>
				)}
				{handleDuplicate && (
					<ButtonWithIcon
						className={classes.actionButton}
						onClick={() => handleDuplicate(id)}
						featherIcon="Copy"
					/>
				)}
				{handleDelete && (
					<ButtonWithIcon className={classes.actionButton} onClick={() => handleDelete(id)} featherIcon="X" />
				)}
				{showLogs && (
					<ButtonWithIcon
						className={classes.actionButton}
						onClick={() => showLogs(id)}
						featherIcon="FileText"
					/>
				)}
			</div>
		</TableCell>
	);
}

export default List;
